module.exports = __webpack_public_path__ + "img/demo_star_wars.e0d00681.jpeg";